module.exports = __webpack_public_path__ + "img/jpg.40d2a410.png";